export const retriggerMessages = {
  MEETING_FOR_TODAY_IS_IN_SYNC:
    'Das heutige Zoom-Meeting ist bereits angelegt und kann nicht nochmals angelegt werden.',
  MEETING_FOR_TODAY_IS_OUT_OF_SYNC:
    'Ein Referenten- oder Uhrzeitwechsel hat stattgefunden. Bitte für heute ein neues Zoom-Meeting anlegen.',
  MEETING_FOR_TODAY_AUTO_CREATION_FAILED:
    'Das heutige Zoom-Meeting konnte nicht automatisch angelegt werden. Dies muss bitte manuell nachgeholt werden.',
  NO_MEETING_FOR_TODAY: 'Die Veranstaltung findet nicht heute statt, deshalb kann kein Zoom-Meeting angelegt werden.',
  VERANSTALTUNG_NOT_FIXED: 'Das Zoom-Meeting kann nicht angelegt werden, weil der Status nicht "fixiert" ist',
  VERANSTALTUNG_HAS_NO_REFERENT: 'Das Zoom-Meeting kann nicht angelegt werden, weil kein Referent zugeordnet ist.',
};
